import * as React from "react"
import { cn } from "@/lib/utils"

export interface UnpairIconProps extends React.SVGProps<SVGSVGElement> {
  /**
   * Size of the icon in pixels
   * @default 18
   */
  size?: number
}

/**
 * Unpair icon as SVG (unlock symbol)
 *
 * This icon represents the unpair/disconnect action in the ANYW3AR app.
 *
 * @example
 * ```tsx
 * <UnpairIcon />
 * <UnpairIcon size={16} className="text-red-600" />
 * ```
 */
export const UnpairIcon = React.forwardRef<SVGSVGElement, UnpairIconProps>(
  ({ size = 18, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 11 11"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        className={cn("inline-flex shrink-0", className)}
        aria-hidden="true"
        {...props}
      >
        <path d="M1.6,10.3c-.4,0-.7-.1-.9-.3-.2-.2-.3-.5-.3-.9v-3.6c0-.4,0-.7.3-.9.2-.2.5-.3.9-.3h4.8c.4,0,.7.1.9.3.2.2.3.5.3.9v3.6c0,.4-.1.7-.3.9-.2.2-.5.3-.9.3H1.6ZM1.9,9.2h4.1c0,0,.2,0,.2,0,0,0,0-.1,0-.2v-3.3c0-.1,0-.2,0-.2,0,0-.1,0-.2,0H1.9c0,0-.2,0-.2,0,0,0,0,.1,0,.2v3.3c0,.1,0,.2,0,.2,0,0,.1,0,.2,0ZM5.4,4.6v-1.6c0-.6.1-1.1.4-1.5.2-.4.5-.7.9-.9.4-.2.8-.3,1.3-.3s.9.1,1.3.3c.4.2.7.5.9.9.2.4.4.9.4,1.5v1c0,.2,0,.3-.2.4-.1.1-.2.2-.4.2s-.3,0-.4-.2c-.1-.1-.2-.3-.2-.4v-1.1c0-.3,0-.6-.2-.8-.1-.2-.3-.4-.5-.5-.2-.1-.5-.2-.7-.2s-.5,0-.7.2-.4.3-.5.5c-.1.2-.2.5-.2.8v1.6h-1.2Z" />
      </svg>
    )
  }
)

UnpairIcon.displayName = "UnpairIcon"
